export default __webpack_public_path__ + "static/media/angular.b9697bce.webp";